/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Pipe, PipeTransform } from '@angular/core';
import { BaseModel } from '@shared/models';

@Pipe({
    name: 'objectId',
    standalone: false
})
export class ObjectIdPipe implements PipeTransform {
  transform(value: BaseModel, args?: any): any {
    if (null === value) {
      return '';
    }

    return value['@id'].replace( /^\D+/g, '');
  }
}
